import { render, staticRenderFns } from "./PlatformsMultiselect.vue?vue&type=template&id=0409951f&"
import script from "./PlatformsMultiselect.vue?vue&type=script&lang=js&"
export * from "./PlatformsMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports